
export function exportarAExcel(datos, nombreArchivo = 'programas_seleccion.xlsx') {
    // Seleccionar solo las columnas que necesitas
    const datosParaExportar = datos.map(item => ({
        // 'ID Versión': item.pv_id,
        // 'ID Programa': item.pu_id,
        // LBBPGM2H5MBB97971  CHASIS
        // QJ164FML0244268 MOTOR
        // 2TPWND2B CRPVA
        'Código': item.codigos,
        'Programa': item.programa_nombre,
        'Gestión': item.gestion,
        'Resolución': item.resolucion_aprobacion_universidad,
        'Versión': item.version,
        'Fecha Inicio': item.fecha_inicio ? new Date(item.fecha_inicio).toLocaleDateString() : '',
        'Fecha Fin': item.fecha_fin ? new Date(item.fecha_fin).toLocaleDateString() : '',
        'Sede': item.sede_name,
        'Estado': item.estado,
        'Disponible para Oferta': item.disponible_para_oferta ? 'Sí' : 'No',
        'Programas Aperturados': item.programas_aperturados
    }));

    // Crear el libro de trabajo
    const wb = window.XLSX.utils.book_new();
    
    // Convertir los datos a hoja de cálculo
    const ws = window.XLSX.utils.json_to_sheet(datosParaExportar);
    
    // Ajustar el ancho de las columnas automáticamente
    const maxWidth = 50;
    const colWidths = Object.keys(datosParaExportar[0] || {}).map(key => ({
        wch: Math.min(
            Math.max(
                key.length,
                ...datosParaExportar.map(row => 
                    String(row[key] || '').length
                )
            ),
            maxWidth
        )
    }));
    ws['!cols'] = colWidths;
    
    // Agregar la hoja al libro
    window.XLSX.utils.book_append_sheet(wb, ws, 'Programas');
    
    // Descargar el archivo
    window.XLSX.writeFile(wb, nombreArchivo);
}